function openTab(event, tabId) {

    // console.log("Open Tabs Parameters", event, tabId);
    
    // Declare all variables
    var i, tabcontent, tablinks;

    // Get all elements with class="tab content" and hide them
    tabcontent = document.getElementsByClassName("tab content");
    if (tabcontent.length > 1) {
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    if(document.getElementById(tabId)) {
        document.getElementById(tabId).style.display = "block";
    }

    if (event) {
        // Get all elements with class="tablinks" and remove the class "active"
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }

        // Set the Current tablinks with active class
        event.currentTarget.className += " active";
    }
}

$(document).ready(function () {
    var tablinks = $('.tablinks');
    if (tablinks && tablinks.length > 0) {
        openTab(null, $('.tablinks.active').first().data('tabid'));
    }
});

$('.tablinks').on('click', function (e) {
    var selectItem = $(this);
    openTab(e, selectItem.data('tabid'));
    e.preventDefault();
});